// "Recently visited" boards and workspaces for the Cmd/Ctrl+B search window.
// Kept per user in this browser (only ids + time — names, paths and access are
// resolved fresh by the API each time the window opens).
const MAX = 20;
const keyFor = (userId) => `aflo-recent-${userId || 'anon'}`;

export const recordVisit = (userId, type, id) => {
  if (!userId || !type || !id) return;
  try {
    const key = keyFor(userId);
    const list = JSON.parse(localStorage.getItem(key) || '[]').filter((r) => !(r.type === type && r.id === id));
    list.unshift({ type, id, at: Date.now() });
    localStorage.setItem(key, JSON.stringify(list.slice(0, MAX)));
    window.dispatchEvent(new Event('aflo:recent-changed'));
  } catch { /* storage full / private mode — recents are a convenience */ }
};

export const recentTokens = (userId) => {
  try {
    return JSON.parse(localStorage.getItem(keyFor(userId)) || '[]').map((r) => `${r.type}:${r.id}`);
  } catch {
    return [];
  }
};

// Ask the search window to open (the header's search button uses this).
export const openQuickSearch = () => window.dispatchEvent(new Event('aflo:open-search'));
